<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="login">
                <card type="login">
                  <h3 slot="header" class="header text-center">Đăng nhập hệ thống </h3>

                  <fg-input v-model="userData.username" addon-left-icon="nc-icon nc-single-02"
                            placeholder="Tên tài khoản"></fg-input>

                  <fg-input v-model="userData.password" addon-left-icon="nc-icon nc-key-25" placeholder="Mật khẩu"
                            type="password"></fg-input>

                  <br>

                  <p-button native-type="submit" slot="footer" type="warning" round block class="mb-3">Đăng nhập</p-button>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Checkbox, Button } from 'src/components/UIComponents';
  import AppNavbar from './Layout/AppNavbar'
  import AppFooter from './Layout/AppFooter'
  import axios from "axios";
  import VueAxios from "vue-axios";
  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
    created(){
                if (localStorage["token"]) {
            // console.log("login success")  
            that.$router.push('/listNode');
                }
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },

      login() {
        var that = this;
        axios({url: '/Account/Login', 
               data: that.userData, 
               method: 'POST' })
        .then(function(res){
          const token = res.data.tokenkey;
          const privilege = JSON.stringify(res.data.nodesAllow);
          const permission = res.data.permission;
          const info = res.data.info;
          // console.log(token + ' + ' + privilege);
          if (token) {     
            localStorage.setItem('token', token) // store the token in localstorage
            localStorage.setItem('privilege', privilege)
            localStorage.setItem('user', that.userData.username) 
            localStorage.setItem('permission', permission) 
            localStorage.setItem('info', info)             
          } else {
            localStorage.removeItem('token') 
            alert("Sai tên đăng nhâp hoặc mật khẩu")
          }
          return(res)
        })
        .catch(function(err){
          localStorage.removeItem('token') // if the request fails, remove any possible user token if possible
          alert("Đăng nhập thất bại")
          return(err)
        })
        .then(function(res){
          if (localStorage["token"]) {
            // console.log("login success")  
            that.$forceUpdate();
            that.$router.push('/listNode')              // redirect to homepage after successfully logged in
            // location.reload();        // Reload sidebar component
          } else {
            // console.log("login failed")  
          }                    
        })
      }
    },
    data() {
      return {
        userData: {
          username: '',
          password: ''
        },
      }
    },
    beforeDestroy() {
      this.closeMenu()
    }
  }
</script>
<style>
</style>
